import { render, staticRenderFns } from "./GrowthObserverSDeviation.vue?vue&type=template&id=4e291a38&"
import script from "./GrowthObserverSDeviation.vue?vue&type=script&lang=js&"
export * from "./GrowthObserverSDeviation.vue?vue&type=script&lang=js&"
import style0 from "./GrowthObserverSDeviation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports